import * as React from 'react'
import type { SVGProps } from 'react'
const UnknownPayment = (props: SVGProps<SVGSVGElement>) => (
<svg {...props} width="89" height="90" viewBox="0 0 89 90" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M88.8318 44.9999L87.3316 56.4772L82.899 67.1688L75.8471 76.3471L66.6683 83.399L55.9768 87.8316L44.4999 89.3318L33.0225 87.8316L22.3306 83.399L13.1522 76.3471L6.10073 67.1683L1.66812 56.4768L0.167969 44.9999L1.66812 33.5225L6.10073 22.8306L13.1526 13.6522L22.331 6.60073L33.0225 2.16812L44.4999 0.667969L55.9772 2.16812L66.6688 6.60073L75.8471 13.6526L82.899 22.831L87.3316 33.5225L88.8318 44.9999Z" fill="#FFAA00"/>
</svg>

)
export default UnknownPayment
